import { Card, CardBody, Col, FormGroup, Input, Label, Table } from "reactstrap";
import { ManageOrderTitle } from "../../../../../Constants/Constants";
import DashboardCommonHeader from "../../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import { ManageOrderTableBody } from "./ManageOrderTableBody";

const ManageOrder = () => {
  return (
    <Col xl="7" md="6">
      <Card className="latest-sales">
        <DashboardCommonHeader title={ManageOrderTitle} dropdownClass="dropdown-toggle" />
        <CardBody>
          <div className="table-responsive custom-scrollbar">
            <Table className="display">
              <thead>
                <tr>
                  <th>
                    <FormGroup check>
                      <Input type="checkbox" />
                      <Label check />
                    </FormGroup>
                  </th>
                  <th>Products name</th>
                  <th>ID </th>
                  <th>Date</th>
                  <th>Price</th>
                  <th>Status</th>
                  <th>Quantity</th>
                </tr>
              </thead>
              <ManageOrderTableBody/>
            </Table>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ManageOrder;
